import moment from 'moment'

export const getLeanPeriodKey = (week?: number | string, startDay?: string): string => {
  const source = startDay
    ? moment(startDay, 'YYYY-MM-DD', true)
    : moment(String(week || ''), 'YYYYWW', true)

  if (!source.isValid()) return ''

  return `${source.isoWeekYear()}-W${String(source.isoWeek()).padStart(2, '0')}`
}
